export default __webpack_public_path__ + "static/media/(28).e2252d4d.jpg";